import React from "react";
import { MapPin } from "lucide-react";

export const WB_DISTRICTS = ["Alipurduar", "Bankura", "Birbhum", "Cooch Behar", "Dakshin Dinajpur", "Darjeeling", "Hooghly", "Howrah", "Jalpaiguri", "Jhargram",
  "Kalimpong", "Kolkata", "Malda", "Murshidabad", "Nadia", "North 24 Parganas", "Paschim Bardhaman", "Paschim Medinipur",
  "Purba Bardhaman", "Purba Medinipur", "Purulia", "South 24 Parganas", "Uttar Dinajpur"];

export const DistrictBar = ({ leads, value, onChange }) => {
  const counts = leads.reduce((m, l) => { const k = l.district || "Unknown"; m[k] = (m[k] || 0) + 1; return m; }, {});
  const keys = [...WB_DISTRICTS.filter((d) => counts[d]), ...Object.keys(counts).filter((d) => !WB_DISTRICTS.includes(d) && d !== "Unknown"), ...(counts.Unknown ? ["Unknown"] : [])];
  const chip = (k, label, n) => (
    <button key={k} type="button" onClick={() => onChange(k)} data-testid={`tc-district-${k.toLowerCase().replace(/\s+/g, "-")}`}
      className={`px-3 h-8 rounded-full text-xs border transition-colors ${value === k ? "bg-emerald-500 text-[#04221a] border-emerald-500 font-bold" : "border-border/60 text-white hover:border-emerald-400/60"}`}>
      {label} <span className="opacity-70">({n})</span>
    </button>
  );
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="tc-district-bar">
      <MapPin className="w-4 h-4 text-emerald-300" />
      {chip("", "All districts", leads.length)}
      {keys.map((k) => chip(k, k === "Unknown" ? "No district" : k, counts[k]))}
    </div>
  );
};

export const SetDistrict = ({ count, onSet }) => (
  <select value="" onChange={(e) => e.target.value && onSet(e.target.value)} data-testid="tc-set-district"
    className="h-9 rounded-md border border-emerald-400/40 bg-card/60 px-2 text-sm text-emerald-200">
    <option value="">Set district for {count}…</option>
    {WB_DISTRICTS.map((d) => <option key={d} value={d}>{d}</option>)}
  </select>
);
